import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CloudSunIcon, GiftIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} volumi completi`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonus esclusivi`
}];
export function Hero() {
  const scrollToOffer = () => document.getElementById('offerta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden" data-id="element-82" data-mp="sb1e1x0sed9q">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-83" data-mp="s9gji7eh2ubv">
        <span className="flex-1 bg-abyss" data-id="element-84" data-mp="nb6k1klpt7kg" />
        <span className="w-24 bg-celeste shadow-[0_0_10px_rgba(94,200,242,0.6)]" data-id="element-85" data-mp="neauv0tor1k3" />
        <span className="flex-1 bg-abyss" data-id="element-86" data-mp="3d33cssqt6ji4" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-87" data-mp="381xl8y8vx2a6">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-celeste/40 bg-ink/55 px-4 py-2 text-[11px] font-bold uppercase tracking-[.14em] text-white backdrop-blur-md sm:text-xs" data-id="element-88" data-mp="3j8sfe0v2xjpu">
          <CloudSunIcon className="h-4 w-4 shrink-0 text-celeste drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-89" data-mp="30ib0az366mmy" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-90" data-mp="35akifsy1mieo">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full drop-shadow-[0_0_30px_rgba(94,200,242,0.3)]" data-id="element-91" data-mp="2hjyof5kviyno" />
        </motion.div>

        

        <div className="mt-8" data-id="element-92" data-mp="s2b7hx6yyh4m">
          <Button onClick={scrollToOffer} arrow className="w-full sm:w-auto" data-id="element-93" data-mp="s3mb9x0ezovq">
            Voglio l&apos;Edizione Docenti
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-94" data-mp="iboywmxo6qvf">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-celeste/25 bg-ink/55 px-3 py-2 backdrop-blur-md" data-id="element-95" data-mp="dbapp1kc1avt">
              <Icon className="h-3.5 w-3.5 text-celeste drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-96" data-mp="161j7utevbvae" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}